<p class="margin-1rem" *ngIf="!isError; else docNotFound">{{documentViewerInfoMessage}}</p>
<ng-template #docNotFound>
  <app-error [errorMessage]="documentErrorMessage"></app-error>
</ng-template>
